
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4F71E8","fill-rule":"evenodd","d":"M12 21l.512-.463C16.813 16.644 19 13.244 19 10.256 19 6.024 15.813 3 12 3s-7 3.024-7 7.256c0 2.988 2.187 6.387 6.488 10.281L12 21zm3.5-10.876c0-1.863-1.567-3.374-3.5-3.374s-3.5 1.51-3.5 3.374S10.067 13.5 12 13.5s3.5-1.51 3.5-3.375z","clip-rule":"evenodd"}})])
          )
        }
      }
    